import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import ImageStatic from '../ImageStatic'

import styles from './styles'


const decorators = [
  memoized,
]

function ClientFocus(props) {
  const { title, description, icon } = props

  return (
    <li>
      <p className="title">{title}</p>
      <p className="description">{description}</p>
      <ImageStatic
        className="icon"
        src={`/images/icons/${icon}.svg`}
      />
      <style jsx>{styles}</style>
    </li>
  )
}

ClientFocus.icons = {
  agency: 'agency',
  brand: 'brand',
  startup: 'startup',
}

ClientFocus.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.oneOf(Object.values(ClientFocus.icons)).isRequired,
}

ClientFocus = chainDecorators(decorators, ClientFocus)

export default ClientFocus
